import { useQuery } from "@rocicorp/zero/react"
import { Navigate, useSearch } from "@tanstack/react-router"

import { queries } from "@productlane/zero/queries"

import { MetaInfo } from "@/components/meta-info"
import { SettingsHeader } from "../settings-header"
import { PersonalSlackNotificationSection } from "./personal-slack-notification-section"

export function NotificationSlackSettingsPage() {
	const [user, result] = useQuery(queries.currentUser())
	const [workspace] = useQuery(queries.currentWorkspace())
	const connected = useSearch({ strict: false, select: (s) => s.connected })

	if (!user) return null

	// Not connected: the overview row carries the Connect Slack button instead.
	// Right after the OAuth callback the new row can trail the replica, so wait for it.
	if (!user.memberships?.personalSlackNotificationSettings) {
		if (result.type !== "complete" || connected !== undefined) return null
		return <Navigate to="/settings/notifications" replace />
	}

	return (
		<>
			<MetaInfo title="Slack notifications" />

			<SettingsHeader
				title="Slack"
				subtitle="Get a direct message in Slack for the events you pick."
			/>

			<PersonalSlackNotificationSection
				data={user}
				docsProposalCadence={workspace?.docsProposalCadence}
			/>
		</>
	)
}
